import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const money = (n) =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD" });

// Shopify CDN on-the-fly resizing (keeps mobile payloads small). Non-Shopify URLs returned as-is.
export const cdnImg = (url, w) =>
  url && url.includes("cdn.shopify.com") ? `${url}${url.includes("?") ? "&" : "?"}width=${w}` : url;

export const cdnSrcSet = (url) =>
  url && url.includes("cdn.shopify.com")
    ? `${cdnImg(url, 400)} 400w, ${cdnImg(url, 600)} 600w, ${cdnImg(url, 800)} 800w, ${cdnImg(url, 1000)} 1000w`
    : undefined;

